import styled from "styled-components";
import useRegister from "../../hooks/authorization/useRegister";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import Modal from "../../components/common/Modal";

function Register(){
    const {inputs, inputDescriptions, onInputChangeHandler, onRegisterClickHandler,
        isOpenModal, modal, onGetPhoneAuthorizationCodeHandler, onSendPhoneAuthorizationCodeHandler,
        inputAuthorizationCode, onInputAuthorizationCodeChangeHandler, isOpenAuthorizationInput
    } = useRegister();
    return(
        <Container>
            <Header/>
            <Modal isOpen={isOpenModal} title={modal.title} content={modal.content} onClose={modal.onConfirmClickHandler}/>
            <Wrapper>
                <Title>회원가입</Title>
                <Inputs>
                    <InputWrap>
                        <Input placeholder="이름" name="name" value={inputs.name} onChange={onInputChangeHandler}/>
                        {inputs.name ? <Description error={inputDescriptions.name ? "true" : "false"} >{inputDescriptions.name ? inputDescriptions.name : '✓'}</Description> : null} 
                    </InputWrap>
                    <InputWrap>
                        <PhoneWrap>
                            <Input placeholder="전화번호" name="tel" value={inputs.tel} onChange={onInputChangeHandler}/>
                            {inputs.tel && !inputDescriptions.tel && !inputAuthorizationCode ? <ButtonCode id="button-get-phone-code" onClick={onGetPhoneAuthorizationCodeHandler}>코드 받기</ButtonCode> : null}
                        </PhoneWrap>
                        {isOpenAuthorizationInput && <PhoneWrap>
                            <Input placeholder="인증코드 6자리" name="authorizationCode" value={inputAuthorizationCode} onChange={onInputAuthorizationCodeChangeHandler}/>
                            <ButtonCode onClick={onSendPhoneAuthorizationCodeHandler}>코드 전송</ButtonCode> 
                        </PhoneWrap>}
                        {inputs.tel ? <Description error={inputDescriptions.tel ? "true" : "false"} >{inputDescriptions.tel ? inputDescriptions.tel : '✓'}</Description> : null}
                    </InputWrap>
                    <InputWrap>
                        <Input placeholder="이메일 (아이디)" name="id" value={inputs.id} onChange={onInputChangeHandler}/>
                        {inputs.id ? <Description error={inputDescriptions.id ? "true" : "false"}>{inputDescriptions.id ? inputDescriptions.id : '✓'}</Description> : null} 
                    </InputWrap>
                    <InputWrap>
                        <Input type="password" placeholder="비밀번호 (최소 6자리 영문+숫자)" name="password" value={inputs.password} onChange={onInputChangeHandler}/>
                        {inputs.password ? <Description error={inputDescriptions.password ? "true" : "false"} >{inputDescriptions.password ? inputDescriptions.password : '✓'}</Description> : null} 
                    </InputWrap>
                    <InputWrap>
                        <Input type="password" placeholder="비밀번호 재입력" name="password_re" value={inputs.password_re} onChange={onInputChangeHandler}/>
                        {inputs.password_re ? <Description error={inputDescriptions.password_re ? "true" : "false"} >{inputDescriptions.password_re ? inputDescriptions.password_re : '✓'}</Description> : null} 
                    </InputWrap>
                    <ButtonRegister onClick={onRegisterClickHandler}>회원가입</ButtonRegister>
                </Inputs>
            </Wrapper>
            <Footer/>
        </Container>
    )
}

const Container = styled.div`
    min-height: 100vh;
    min-width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 400px;
    width: 100%;
    padding: 30px;
    gap: 30px;
    margin-top: 120px;
    margin-bottom: 120px;
`

const Title = styled.span`
    color: black;
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    text-align: center;
`

const Inputs = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

const InputWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
`

const Description = styled.div`
    width: 100%;
    font-size: 12px;
    padding: 0px 8px;
    color:${(props) => props.error === "true" ? "red" : "green"};
`

const PhoneWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

const ButtonCode = styled.button`
    background: #007912;
    border-radius: 12px;
    border: none;
    padding:12px;
    color: #FFF;
    font-weight: 700;
    flex-shrink: 0;
    animation-name: slideIn;
    animation-duration: 0.5s;
    cursor: pointer;
`

const Input = styled.input`
    width: 100%;
    padding: 12px;
    border-radius: 12px;
    border: 1px solid #ccc;
    &::placeholder{
        color: #999;
    }
`

const ButtonRegister = styled.button`
    background: #007912;
    border-radius: 20px;
    border: none;
    padding:12px;
    color: #FFF;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
`

export default Register;